const SET_ERROR_FIELD = 'SET_ERROR_FIELD'

const state = {
  errorField: '',
}

const mutations = {
  [SET_ERROR_FIELD]: (state, value) => {
    state.errorField = value
  },
}

const actions = {
  setErrorData({ commit }, val) {
    commit(SET_ERROR_FIELD, val)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
